import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { DiscountService } from 'src/app/services/discount.service';
import { scrollToSelector } from 'src/utils';
import { Logger } from '@shared/common/logger';
import type { ICommonBookData } from '@shared/jp/models';
import { BooksService } from 'src/app/shared/book-page-common/services/books.service';
import { Router } from '@angular/router';
import { faqDataCondensed } from 'src/app/data/faq/data';
import { ROUTE_PATH_FAQ } from '@studiobuki/web-core/lib/routing';
import { stepsData } from 'src/app/data/steps/data';
import type { IInputNameToValueMap, TInput } from '@shared/common/data/inputs';
import { IBookPreview } from '@shared/jp/data/products';
import { BOOK_ALIAS_TO_ID_MAP } from '@shared/jp/product';
import {
  reviewsData,
  reviewsDataFKBook1,
  reviewsDataFKBook2,
} from 'src/app/data/reviews/reviews';
import {
  descriptionDataAlphabetTrain,
  descriptionDataAnpanmanBirthday,
  descriptionDataMainichiKinenbi,
} from 'src/app/data/description/description';

const log = new Logger('Preview -> SectionDetailsComponent');

// const giftHref = `${BASE_HREF}${ROUTE_PATH_GIFT_BUY}`;

@Component({
  selector: 'app-section-details',
  templateUrl: './section-details.component.html',
  styleUrls: ['./section-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionDetailsComponent implements OnInit {
  @Input() book!: IBookPreview;

  public readonly reviewsDataFKBook1 = reviewsDataFKBook1;

  public readonly reviewsDataFKBook2 = reviewsDataFKBook2;

  public readonly faqDataCondensed = faqDataCondensed;

  public readonly getErrorText = (invalidInput: TInput) =>
    // `TODO: Something went wrong with ${invalidInput.label}`;
    `[※主人公の名前を入力してください]`;

  public readonly stepsData = stepsData;

  public readonly reviewsData = reviewsData;

  public descriptionData: any;

  constructor(
    public media: MediaObserver,
    public discountService: DiscountService,
    private _router: Router,
    private _booksService: BooksService,
  ) {}

  ngOnInit() {
    switch (this.book.alias) {
      case 'froebelkan':
        this.descriptionData = descriptionDataAnpanmanBirthday;
        break;
      case 'froebelkan-alphabet-train':
        this.descriptionData = descriptionDataAlphabetTrain;
        break;
      case 'froebelkan-mainichi-kinenbi':
        this.descriptionData = descriptionDataMainichiKinenbi;
        break;
      default:
        this.descriptionData = null; // или какое-то значение по умолчанию
        break;
    }
  }

  public async submitted(value: IInputNameToValueMap) {
    log.info('submitted', value);
    // const { alias, gift } = this;

    const common: Partial<ICommonBookData> = {};

    // if (gift) {
    //   common.gift = gift;

    //   const userGift = await this._firebaseService.getUserGift(gift);

    //   if (checkUserGift(userGift)) {
    //     common.cover = userGift.book.cover;
    //   }
    // }

    const newBookId = await this._booksService.createBookByAlias(
      this.book.alias,
      value,
      common,
    );

    log.info('created book', newBookId);

    await this._router.navigate(['book', newBookId], {
      // replaceUrl: true,
      // queryParams: {
      //   [ROUTE_QUERY_PARAM_GIFT]: gift,
      // },
    });

    log.info('submit', /* alias, */ value);

    const bookAliasId = BOOK_ALIAS_TO_ID_MAP[this.book.alias];

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!bookAliasId) {
      log.error(`didn't manage to get bookAliasId by alias`, {
        alias: this.book.alias,
        bookAliasId,
      });
    }

    // GATrack(GAGetEvents.getBookPreview(bookAliasId));
  }

  onNoticeButtonClick() {
    scrollToSelector('app-section-banner-mermaid');
  }

  onFaqButtonClick() {
    return this._router.navigate([ROUTE_PATH_FAQ]);
  }
}
